export default function mapFuelTypeLabel(label: string) {
  switch (label) {
    case 'G':
      return 'Gasoline';
    case 'E':
      return 'Electric';
    default:
      return label;
  }
}
